// $('.categories_list01').slick({
//   arrows: false,
//   dots: true,
//   infinite: true,
//   speed: 300,  
//   centerMode: true,
//   variableWidth: true
// });


// var swiper = new Swiper(".categories_list", {
//   slidesPerView: 5,
//   spaceBetween: 24,
//   scrollbar: {
//     draggable: true,
//     el: ".categories_section.swiper-scrollbar"
//   },
//   breakpoints: {
//     650: {
//       slidesPerView: 2,
//     },
//     1040: {
//       spaceBetween: 48,
//       slidesPerView: 5,
//     },
//   },
// });
window.onload = function() {
  $('.categories_list').slick({
    infinite: true,
    slidesToShow: 5,
    centerMode: true,
    arrows: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
};

$(document).ready(function () {
  const $slider = $('.js-product-card-images');
  // Destroy Slick if already initialized
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  // Apply CSS styles using jQuery
  $slider.find('.slide').css({
    padding: '10px',
    'box-sizing': 'border-box',
    'text-align': 'center'
  });
  $slider.find('.slide img').css({
    width: 'auto',
    height: 'auto',
    display: 'block',
    margin: '0 auto'
  });
  // Re-initialize Slick slider
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});






